import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, X, CreditCard } from 'lucide-react';

export default function TrialBanner({ billing, onDismiss }) {
  const navigate = useNavigate();

  if (!billing) return null;

  const { subscription_status, days_left_in_trial, is_active } = billing;

  // Expired trial
  if (subscription_status === 'trialing' && !is_active) {
    return (
      <div style={{
        background: '#FEF2F2', borderBottom: '1px solid #FECACA',
        padding: '10px 24px', display: 'flex', alignItems: 'center', gap: 12,
      }}>
        <AlertTriangle size={16} color="#DC2626" />
        <span style={{ flex: 1, fontSize: 13, color: '#991B1B', fontWeight: 500 }}>
          Your 14-day free trial has expired. Subscribe to continue using Service Tech Manager.
        </span>
        <button
          onClick={() => navigate('/upgrade')}
          style={{
            background: '#DC2626', color: '#fff', border: 'none', borderRadius: 6,
            padding: '6px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 6,
          }}
        >
          <CreditCard size={13} /> Subscribe Now
        </button>
      </div>
    );
  }

  // Past due
  if (subscription_status === 'past_due') {
    return (
      <div style={{
        background: '#FFF7ED', borderBottom: '1px solid #FED7AA',
        padding: '10px 24px', display: 'flex', alignItems: 'center', gap: 12,
      }}>
        <AlertTriangle size={16} color="#EA580C" />
        <span style={{ flex: 1, fontSize: 13, color: '#9A3412', fontWeight: 500 }}>
          Your last payment failed. Please update your payment method to avoid interruption.
        </span>
        <button
          onClick={() => navigate('/billing')}
          style={{
            background: '#EA580C', color: '#fff', border: 'none', borderRadius: 6,
            padding: '6px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
          }}
        >
          Fix Payment
        </button>
      </div>
    );
  }

  // Active trial — show days remaining if ≤ 7
  if (subscription_status === 'trialing' && is_active && days_left_in_trial <= 7) {
    return (
      <div style={{
        background: '#EFF6FF', borderBottom: '1px solid #BFDBFE',
        padding: '10px 24px', display: 'flex', alignItems: 'center', gap: 12,
      }}>
        <AlertTriangle size={16} color="#2563EB" />
        <span style={{ flex: 1, fontSize: 13, color: '#1E40AF', fontWeight: 500 }}>
          {days_left_in_trial === 0
            ? 'Your trial expires today!'
            : `Your free trial expires in ${days_left_in_trial} day${days_left_in_trial === 1 ? '' : 's'}.`}
          {' '}Subscribe now to keep your data and avoid interruption.
        </span>
        <button
          onClick={() => navigate('/upgrade')}
          style={{
            background: '#2563EB', color: '#fff', border: 'none', borderRadius: 6,
            padding: '6px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 6,
          }}
        >
          <CreditCard size={13} /> Upgrade
        </button>
        {onDismiss && (
          <button onClick={onDismiss} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6B7280' }}>
            <X size={14} />
          </button>
        )}
      </div>
    );
  }

  return null;
}
